import { ContainerModule } from 'inversify';
import AskAiChatRepository from '@/creditflowresearch/infrastructure/repository/AskAiChatRepository';
import AskAiChatSubscriptionRepository from '@/creditflowresearch/infrastructure/repository/AskAiChatSubscriptionRepository';
import AiSidebarRepository from '@/creditflowresearch/infrastructure/repository/AiSidebarRepository';
import AskAiPromptsRepository from '@/creditflowresearch/infrastructure/repository/AskAiPromptsRepository';
import AskAiLlmSettingsRepository from '@/creditflowresearch/infrastructure/repository/AskAiLlmSettingsRepository';

export const askAiChatModule = new ContainerModule(({ bind }) => {
  bind(AskAiChatRepository).toSelf().inSingletonScope();
  bind(AskAiChatSubscriptionRepository).toSelf().inSingletonScope();
  bind(AiSidebarRepository).toSelf().inSingletonScope();
  bind(AskAiPromptsRepository).toSelf().inSingletonScope();
  bind(AskAiLlmSettingsRepository).toSelf().inSingletonScope();
});

export default askAiChatModule;
